export const EARNINGS_IMPORT_CONFIG = Object.freeze({
  glovo: {
    idColumnKeys: ['riderid', 'rider_id'],
    amountColumnKeys: ['totaltobetransferedtoglover'],
  },
  wolt: {
    idColumnKeys: ['id', 'courierid', 'courier_id'],
    amountColumnKeys: [
      'totalamountwtips',
      'totalamountwithtips',
      'totalearnings',
      'total',
      'totalpayout',
      'netpayout',
    ],
  },
});

export const HOURS_IMPORT_CONFIG = Object.freeze({
  glovo: {
    idColumnKeys: ['riderid', 'rider_id'],
    amountColumnKeys: ['sumcdtinminutes', 'sumcdtminutes'],
    distanceMetersColumnKeys: ['spdistance', 'sp distance'],
  },
  wolt: {
    idColumnKeys: ['id'],
    amountColumnKeys: ['totalontasktime', 'totalon-tasktime', 'totalontask'],
    distanceMetersColumnKeys: ['on-task distance (meters)', 'ontaskdistancemeters', 'on task distance meters'],
  },
});

